import React from 'react';
const stats = [{
  value: '+1.200',
  label: 'estudiantes confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'MR',
  quote: '"Llegué a tercer año con apuntes de cinco compañeras que no coincidían entre sí. Con el Megapack tuve por primera vez un sistema claro para saber qué estudiar y en qué orden. Aprobé Evaluación Nutricional con 9."',
  author: '— Martina R., Córdoba | 3° año Nutrición UNC'
}, {
  initials: 'JV',
  quote: '"Siempre llegaba a los parciales sin saber si había estudiado lo correcto. Eso cambió: tengo el contenido organizado por ejes, sé cómo repasar y llegué a los finales mucho más tranquilo. Ya aprobé 4 materias."',
  author: '— Julián V., Buenos Aires | 4° año Nutrición UBA'
}, {
  initials: 'CP',
  quote: '"Estaba a punto de recursar Nutrición Clínica porque no encontraba material que se entienda. El Megapack tiene todo explicado con el lenguaje que usan en las cursadas. Fue el cambio que necesitaba."',
  author: '— Camila P., Rosario | 3° año Nutrición UNR'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 15%, rgb(220,252,231) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-279">
      <div className="mx-auto max-w-4xl" data-id="element-280">

        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-281">
          {stats.map(stat => <div key={stat.label} data-id="element-282">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-283">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-green-700" data-id="element-284">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-285">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-green-400/30 rounded-lg p-3 shadow-sm" data-id="element-286">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-green-700" style={{
            backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 15%, rgb(220,252,231) 85%, rgb(240,253,244) 100%)'
          }} data-id="element-287">
                {t.initials}
              </div>
              <div data-id="element-288">
                <div className="mb-1 text-[10px] text-green-600" data-id="element-289">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-290">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-291">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}